(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5619],{

/***/ 53918:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/universities/[country]",
      function () {
        return __webpack_require__(69742);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Universities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50281);
/* harmony import */ var _components_MetaTagsComp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47046);





// Utility function to format the country slug
const formatCountrySlug = (slug)=>{
    let formattedSlug = slug.split("-").map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    if (formattedSlug === "Usa") {
        formattedSlug = "USA";
    } else if (formattedSlug === "Uk") {
        formattedSlug = "UK";
    }
    return formattedSlug;
};
const CountryUniversities = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { country  } = router.query;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#313145");
        customStyle.setProperty("--navbar-menu-color", "#ffff");
    }, []);
    const countrySlug = country;
    const pageNumber = "page-1";
    const formattedCountrySlug = formatCountrySlug(countrySlug);
    const countryMeta = props.universityCountries.find((country)=>country.label === formattedCountrySlug)?.meta;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            countryMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MetaTagsComp__WEBPACK_IMPORTED_MODULE_4__/* .MetaTagsComp */ .r, {
                ...countryMeta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Universities__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                ...props,
                countrySlug: countrySlug,
                pageNumber: pageNumber
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (CountryUniversities);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,5707,4750,8219,3001,9774,2888,179], function() { return __webpack_exec__(53918); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);